export interface CartItem {
  id: string;
  productId: string;
  name: string;
  price: number;         // selling price (GST-inclusive)
  originalPrice: number; // MRP for discount display
  imageUrl: string;
  category: string;
  quantity: number;
  selectedSize?: string;
  selectedColor?: string;
}

const cartKey = (userId: string) => `sf_cart_${userId}`;

const getCart = (userId: string): CartItem[] => {
  try { return JSON.parse(localStorage.getItem(cartKey(userId)) || '[]'); } catch { return []; }
};

const saveCart = (userId: string, items: CartItem[]) => {
  localStorage.setItem(cartKey(userId), JSON.stringify(items));
};

export const cartService = {
  getCartItems(userId: string): CartItem[] {
    return getCart(userId);
  },

  addToCart(userId: string, item: Omit<CartItem, 'id'>): CartItem[] {
    const cart = getCart(userId);
    const existing = cart.find(
      i => i.productId === item.productId &&
           i.selectedSize === item.selectedSize &&
           i.selectedColor === item.selectedColor
    );
    if (existing) {
      existing.quantity += item.quantity;
    } else {
      cart.push({ ...item, id: Math.random().toString(36).substring(2) });
    }
    saveCart(userId, cart);
    return cart;
  },

  updateQuantity(userId: string, id: string, quantity: number): CartItem[] {
    const cart = getCart(userId).map(i => i.id === id ? { ...i, quantity } : i);
    saveCart(userId, cart);
    return cart;
  },

  removeItem(userId: string, id: string): CartItem[] {
    const cart = getCart(userId).filter(i => i.id !== id);
    saveCart(userId, cart);
    return cart;
  },

  clearCart(userId: string): void {
    localStorage.removeItem(cartKey(userId));
  },

  getCount(userId?: string): number {
    if (!userId) return 0;
    return getCart(userId).reduce((sum, i) => sum + i.quantity, 0);
  },
};
